import type { IconName } from '@/components/icon';

export const getFootnoteListId = (citeId: string) => `cite-${citeId}`;

export const getFootnoteRefId = (citeId: string) => `cite-ref-${citeId}`;

const googleDriveDomains = [
  'docs.google.com',
  'sheets.google.com',
  'slides.google.com',
  'drive.google.com',
];

export const getIcon = (host: string | null): IconName => {
  if (host === null) {
    return 'Globe';
  }
  if (host.endsWith('.atlassian.net') || host.endsWith('.atlassian.com')) {
    return 'Confluence';
  }
  if (host.endsWith('supersimple.io')) {
    return 'Supersimple';
  }
  if (host.endsWith('slack.com')) {
    return 'Slack';
  }
  if (host.endsWith('linear.app')) {
    return 'Linear';
  }
  if (googleDriveDomains.some((domain) => host.endsWith(domain))) {
    return 'GoogleDrive';
  }
  if (host.endsWith('notion.so') || host.endsWith('notion.site')) {
    return 'Notion';
  }
  if (host.endsWith('hubspot.com')) {
    return 'HubSpot';
  }
  if (host.endsWith('aircall.io')) {
    return 'Aircall';
  }

  return 'Globe';
};
